import React from 'react';
import type { CurrencyCode } from '@99designs/i18n';

export const COMPLETED_STEP_EVENT_NAME = 'Completed Onboarder Step';

export type GenericStepData = Record<string, string | undefined | string[]>;

export interface StepHeadingProps<TData> {
    data: TData;
}

export interface StepComponentProps<TData> {
    data: TData;
    onChange: (data: TData) => void;
}

export interface Step<TData> {
    key: string;
    title: string;
    Heading: React.FunctionComponent<StepHeadingProps<TData>>;
    Component: React.FunctionComponent<StepComponentProps<TData>>;
    canGoToNextStep: (data: TData) => boolean;
    isSkippable?: boolean;
    trackCompleted: (data: TData, stepNumber: number) => void;
}

export interface StepResponse {
    question: string;
    answer: React.ReactNode;
}

export interface Config<TData> {
    // The base path for the onboarder
    // All the step paths will be appended after the base path
    basePath: string;

    // The currency used in the onboarder
    currency: CurrencyCode;

    // Current exchange rate
    exchangeRate: number;

    // The screen before the onboarder
    Launcher: React.FunctionComponent;

    // The screen at the end the onboarder
    Recommendation: React.FunctionComponent;

    // Used within the Page Title
    pageTitle: string;

    // Prefix for cookie setting
    storageKeyPrefix: string;

    // Steps is a method because it can change based on the data that was inputted
    steps: (data: TData) => Step<TData>[];

    stepsResponse: (data: TData) => StepResponse[];
}
